import { useState, useEffect } from 'react';
import { Form, Field, FormElement } from '@progress/kendo-react-form';
import {
  FormTextArea,
  FormMultiSelect,
  FormDatePicker,
  FormDropDownList,
} from '../FormComponents';
import { getEmployeeDropdown } from '../../../data/employeeData';
import { getNotePriorities, NOTE_PRIORITY_NORMAL } from '../../../data/notes';
import { dropDown } from '../../../data/interfaces';
import { requiredValidator } from '../Validators';

const AddNoteForm = (props: any) => {
  const [employeeData, setEmployeeData] = useState<dropDown[]>([]);
  const [priorityData, setPriorityData] = useState<dropDown[]>([]);

  useEffect(() => {
    const fetchEmployeeData = async () => {
      const employeeData = await getEmployeeDropdown('');
      setEmployeeData(employeeData);
    };

    const fetchPriorityData = async () => {
      const priorities = await getNotePriorities();
      setPriorityData(priorities.map((p) => ({ text: p.name, value: p.notePriorityId })));
    };

    fetchEmployeeData();
    fetchPriorityData();
  }, []);

  const handleSubmit = (dataItem: any) => {
    console.log("AddNoteForm submitting:", dataItem);
    props.onNoteSubmit(dataItem);
  };

  const searchEmployeeDropdown = async (searchTerm: string) => {
    const employeeData = await getEmployeeDropdown(searchTerm);
    setEmployeeData(employeeData);
  };

  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={props.initialValues || {}}
      render={(formRenderProps) => (
        <FormElement>
          <fieldset className={'k-form-fieldset'}>
            <div className="formik__field__container">
              <Field
                id={'note'}
                name={'note'}
                label={'Note:'}
                component={FormTextArea}
                validator={requiredValidator}
                placeholder="Enter your note..."
                rows={4}
              />
            </div>

            <div className="formik__field__container">
              <Field
                id={'employeesAssignedToId'}
                name={'employeesAssignedToId'}
                label={'Assigned employees:'}
                component={FormMultiSelect}
                data={employeeData}
                setData={setEmployeeData}
                searchDropdown={searchEmployeeDropdown}
                validator={requiredValidator}
                placeholder="Select employees..."
              />
            </div>

            <div className="formik__field__container">
              <Field
                id={'notePriorityId'}
                name={'notePriorityId'}
                label={'Priority:'}
                component={FormDropDownList}
                data={priorityData}
                defaultText={'Normal'}
                defaultValue={NOTE_PRIORITY_NORMAL}
              />
            </div>

            <div className="formik__field__container">
              <Field
                id={'dueDate'}
                name={'dueDate'}
                label={'Due Date (optional):'}
                component={FormDatePicker}
                placeholder="Select due date..."
              />
            </div>
          </fieldset>

          <div className="k-form-buttons">
            <button
              type={'submit'}
              className="submitBtn"
              disabled={!formRenderProps.allowSubmit}
            >
              Add Note
            </button>
          </div>
        </FormElement>
      )}
    />
  );
};

export default AddNoteForm;
